<template>
    <div >
      <DxPopup
        :visible="isVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"        
        :show-close-button="true"
        @hidden="onHiddenReport"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="Title"       
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"       
      >
        <div>
            <MdTitle v-bind:Text="$t('ExceptionDetailsPopup.CExceptions')" v-bind:isSubtitle="true"/>
            <div>
                <MdTable
                  :items="items"
                  :showMessageIsEmpty="ShowMessageIsEmpty"
                  :sticky-header="true"
                  :onRowSelected="onExceptionSelected"
                  :fields="fields"
                />
            </div>
            <MdTitle v-bind:Text="$t('ExceptionDetailsPopup.CDetails')" v-bind:isSubtitle="true"/>
            <div class="mt-2">
                <MdTable
                  :items="claimItems"
                  :showMessageIsEmpty="ShowMessageIsEmpty"
                  :sticky-header="true"
                  :fields="claimFields"
                  v-bind:VisibleViewIcon="true"
                  :onRowSelected="onClaimSelected"
                  :viewIconEvent="ViewIcon"
                  :no-select-on-click="true"
                />              
            </div>
        </div>
    </DxPopup>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { DxPopup } from 'devextreme-vue/popup';
    import ShowMessage from '@/components/messages/ShowMessage.js'

    export default Vue.extend({
        name: "ExceptionDetailsPopup",
        mixins: [ ShowMessage ],
        components: { DxPopup },
        props: {
          Title:String,
          isVisible: Boolean,   
          items: Array,
          fields: Array,   
          claimItems: Array,
          claimFields: Array,
          closeWindow: Function,
          ShowMessageIsEmpty: Boolean,
          onExceptionSelected: Function,
          onClaimSelected: Function,
          ViewIcon: Function
        },
        data() {
            return {
                
            }
        },
        methods: {
            onHiddenReport() {
              this.closeWindow()
            },
        },
        
        mounted () {          
         
        },
    })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  }
</style>
